import { yellow, red, green, italic, lightBlue } from 'kolorist';
import { getTime } from '../timing';
const defaultLogger = {
    trace(context, ...args) {
        console.log(...args);
    },
    debug(context, ...args) {
        console.log(...args);
    },
    warn(context, ...args) {
        console.warn(yellow('WARN: '), ...args);
    },
    error(context, ...args) {
        console.error(red('ERROR: '), ...args);
    },
    fatal(context, ...args) {
        console.error(red('FATAL: '), ...args);
    },
};
let logger = defaultLogger;
export function getLoggerFromContext(context) {
    return {
        trace: (...args) => logger.trace(context, ...args),
        debug: (...args) => logger.debug(context, ...args),
        warn: (...args) => logger.warn(context, ...args),
        error: (...args) => logger.error(context, ...args),
        fatal: (...args) => logger.fatal(context, ...args),
    };
}
export function setLogger(newLogger) {
    logger = newLogger;
}
export function resetLogger() {
    logger = defaultLogger;
}
export const log = {
    trace(...args) {
        return logger.trace({}, ...args);
    },
    debug(...args) {
        return logger.debug({}, ...args);
    },
    warn(...args) {
        return logger.warn({}, ...args);
    },
    error(...args) {
        return logger.error({}, ...args);
    },
    fatal(...args) {
        return logger.fatal({}, ...args);
    },
};
const SERVER_RESPONSE_MAP = {
    str: 'streaming SSR',
    rsc: 'server Components',
    ssr: 'buffered SSR',
};
export function logServerResponse(type, log, request, responseStatus) {
    const coloredResponseStatus = responseStatus >= 500
        ? red(responseStatus)
        : responseStatus >= 400
            ? yellow(responseStatus)
            : responseStatus >= 300
                ? lightBlue(responseStatus)
                : green(responseStatus);
    const fullType = SERVER_RESPONSE_MAP[type] || type;
    const styledType = italic(pad(fullType, '                 '));
    const paddedTiming = pad((getTime() - request.time).toFixed(2) + ' ms', '          ');
    const url = type === 'rsc'
        ? decodeURIComponent(request.url.substring(request.url.indexOf('=') + 1))
        : request.url;
    log.debug(`${request.method} ${styledType} ${coloredResponseStatus} ${paddedTiming} ${url}`);
}
function pad(str, _pad) {
    return (str + _pad).substring(0, _pad.length);
}
